'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:share:activeNavButton');
}

var _invoke = require('../invoke');

/**
 * share.activeNavButton 激活导航栏分享按钮
 *
 * 支持版本
 * + iHotel/7.0+
  * 此版本不支持successCallback,failCallback 客户端说排期比较紧张，7.1版本实现, ios失败没有回调通知
 * @memberof share
 * @static
 * @name activeNavButton
 * @param {Array} channel 渠道
 * @param {Object} conf 配置信息
 * @return {Undefined}
 * @example
 *  hbnb.share.activeNavButton(['weixin','weibo','sinaWeibo'], {
        content: '分享内容',
        detailURL: 'http://i.meituan.com/',
        imageURL: 'http://p1.meituan.net/codeman/799087624091d1d43768b7da396d4a122532.png',
        title: '分享标题'
    });
 */

module.exports = function(channelParam, configParam, successCallback, failCallback) {
    if (process.env.NODE_ENV !== 'production') {
        debug('param channelParam is %j', channelParam);
        debug('param configParam is %j', configParam);
    }
    var p = new Promise(function(resolve, reject) {
        var data = {
            'sinaweibo': 1,
            'qzone': 2,
            'qqweibo': 4,
            'renren': 8,
            'kaixin': 16,
            'sms': 32,
            'email': 64,
            'weixin': 128,
            'weixinfriends': 256,
            'qqclient': 512,
            'all':-1
        };
        var params = {};
        var channel = channelParam || [];
        var config = configParam || {};
        var channelNumber = 0;
        var i;
        var num;
        var d;
        if(channel && Object.prototype.toString.call(channel) == "[object Array]"){
            for (var i = 0, len = channel.length; i < len; i++){
                d = channel[i];
                num = data[d.toLowerCase()];
                channelNumber += num;
                if(config['content_' + d]){
                    params['content_' + num] = config['content_' + d];
                }
            }
            if (config.cid) {
                params.cid = config.cid;
            }
            params.channel = channelNumber;
            params.content =  config.content;
            params.detailURL = config.detailURL;
            params.imageURL =  config.imageURL;
            params.title = config.title;
            params.callback = function (returnData) {
                if (returnData && returnData.status === 'COMPLETE') {
                    if (typeof successCallback === 'function') {
                        successCallback(returnData)
                    }
                } else {
                    if (typeof failCallback === 'function') {
                        failCallback(returnData)
                    }
                }
                resolve(returnData);
                return false;
            };
            _invoke('share', 'enable_nav_share_button', params);
        }

    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/share/active-nav-button.js
// module id = 611
// module chunks = 0